import moment from 'moment';

export const toFuture = (date: moment.Moment, amount: number, unit: moment.unitOfTime.DurationConstructor) => {
  const futureDate = moment().add(amount, unit);

  if (moment(date).isAfter(futureDate)) {
    return date;
  }

  const updatedDate = date
    .clone()
    .hour(futureDate.hour())
    .minute(futureDate.minute());

  return updatedDate;
};

export const timeUntilEndOfDayInMilliseconds = () => {
  return new Date(new Date().setHours(23, 59, 59, 999)).getTime() - new Date().getTime();
};
